import type { ChatMessageContent } from "schemas/generated/chatMessage";

import React, { useState } from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import twMerge from "@replo/design-system/utils/twMerge";
import { ImageOverlay } from "@v2/features/chat/components/chat-elements/chat-message/ImageOverlay";

type ImageMessageContent = Extract<
  ChatMessageContent[number],
  { type: "image" }
>;

export const ImageMessage = ({ src }: { src: string }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const showPlaceholder = !isImageLoaded || hasError;

  const handleClick = () => {
    if (showPlaceholder) {
      return;
    }
    setIsOverlayOpen(true);
  };

  return (
    <>
      <div
        className={twMerge(
          "w-[75px] h-[75px] overflow-hidden rounded-lg cursor-pointer hover:opacity-90 transition-opacity border border-border bg-white",
          showPlaceholder && "cursor-default",
        )}
        onClick={handleClick}
      >
        {showPlaceholder && <Skeleton className="w-full h-full" />}
        <img
          src={src}
          alt="Chat Image Thumbnail"
          className={twMerge(
            "w-full h-full object-cover",
            showPlaceholder && "hidden",
          )}
          onLoad={() => setIsImageLoaded(true)}
          onError={() => setHasError(true)}
        />
      </div>
      <ImageOverlay
        isOpen={isOverlayOpen}
        onClose={() => setIsOverlayOpen(false)}
        imageSrc={src}
        imageAlt="Chat Image Overlay"
      />
    </>
  );
};

interface ImageMessageItemProps {
  item: ImageMessageContent;
}

export const ImageMessageItem = ({ item }: ImageMessageItemProps) => {
  if (item.isHidden) {
    return null;
  }

  return <ImageMessage src={item.image} />;
};
